import _extends from "@babel/runtime/helpers/extends";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import classNames from 'classnames/bind';
import { Picture } from "../../../Picture";
import { Carousel } from "../../../Carousel";
import { useIsDesktopDimension } from "../../../../hooks/useGetDimensionGroup";
import style from "./styles.module.pcss";
var cx = classNames.bind(style);
var paginationControl = function paginationControl(className) {
  return "<div class=\"".concat(cx(className, 'pagination'), "\"></div>");
};
var FALLBACK_PICTURE_LINK = 'https://static.beeline.ru/upload/images/error-content-cat.png';
export var DevicePicture = /*#__PURE__*/React.memo(function (_ref) {
  var device = _ref.device,
    isWithModal = _ref.isWithModal,
    onOpenModal = _ref.onOpenModal;
  var isDesktop = useIsDesktopDimension();
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    singlePicture = _useState2[0],
    setSinglePicture = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    picturesLoadingWithError = _useState4[0],
    setPicturesLoadingWithError = _useState4[1];
  var onErrorHandler = useCallback(function (pictureSrc) {
    return function () {
      var pictures = [].concat(_toConsumableArray(picturesLoadingWithError), [pictureSrc]);
      setPicturesLoadingWithError(pictures);
    };
  }, [setPicturesLoadingWithError, picturesLoadingWithError]);
  var onOpenModalClick = useCallback(function (id, slug) {
    return function () {
      if (onOpenModal) {
        onOpenModal(id, slug);
      }
    };
  }, [onOpenModal]);
  var picturesList = useMemo(function () {
    var _device$imgOptions;
    var pictures = (_device$imgOptions = device === null || device === void 0 ? void 0 : device.imgOptions) !== null && _device$imgOptions !== void 0 ? _device$imgOptions : [];
    return Array.isArray(pictures) ? pictures : [pictures];
  }, [device]);
  useEffect(function () {
    if (!isDesktop || picturesList.length === 1) {
      var _picturesList = _slicedToArray(picturesList, 1),
        picture = _picturesList[0];
      setSinglePicture(picture);
    }
  }, [isDesktop, picturesList]);
  var isCarousel = isDesktop && picturesList.length > 1;
  return isCarousel ? /*#__PURE__*/React.createElement(Carousel, {
    className: cx('swiper'),
    paginatePadding: false,
    settings: {
      watchOverflow: isCarousel,
      pagination: {
        clickable: true,
        renderBullet: function renderBullet(index, className) {
          return paginationControl(className);
        }
      },
      slidesPerView: 1,
      loop: true
    }
  }, picturesList.map(function (picture) {
    var _ref2, _picture$alt;
    var src = picturesLoadingWithError.includes(picture === null || picture === void 0 ? void 0 : picture.src) ? FALLBACK_PICTURE_LINK : undefined;
    return /*#__PURE__*/React.createElement("div", {
      className: cx('wrapper', isWithModal && 'with-cursor'),
      key: "".concat(picture.src),
      onClick: onOpenModalClick(device.id, device.slug)
    }, /*#__PURE__*/React.createElement("img", {
      alt: (_ref2 = (_picture$alt = picture.alt) !== null && _picture$alt !== void 0 ? _picture$alt : picture.title) !== null && _ref2 !== void 0 ? _ref2 : '',
      className: cx('swiper-lazy'),
      loading: "lazy",
      onError: onErrorHandler(picture.src),
      src: src || picture.src
    }), /*#__PURE__*/React.createElement("div", {
      className: "swiper-lazy-preloader"
    }));
  })) : /*#__PURE__*/React.createElement("div", {
    className: cx('wrapper', 'with-cursor'),
    onClick: onOpenModalClick(device.id, device.slug)
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('img-container', (device === null || device === void 0 ? void 0 : device.isSmallPadding) && 'small-img')
  }, /*#__PURE__*/React.createElement(Picture, _extends({
    loading: "lazy"
  }, singlePicture, {
    className: cx('img-styled'),
    src: singlePicture === null || singlePicture === void 0 ? void 0 : singlePicture.src
  }))));
});